// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1536":"fd9de576f7b74c48","2888":"5456359e523f4de3"}[chunkId] + ".css";
};